<template lang="html">
  <div>
    <vx-tooltip :delay="tooltipDelay" :text="tooltipText" :tooltipPosition="tooltipPosition">
   <feather-icon
        icon="RefreshCwIcon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="open"
    />
    </vx-tooltip>
    <vs-popup  :title="popupTitle" :active.sync="active">
      <div> 
        <template v-if="(data.QBInvoiceId != null && data.QBInvoiceId != '')">
          <vs-row class="mt-2">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="font-semibold text-primary">
              <p>{{ $t('are_you_sure') }} {{$t('type_the_following_code_to_continue') }} : {{ data.QBInvoiceId}}</p> 
            </vs-col>
        </vs-row>
        <vs-row class="mt-2">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" >
              <vs-input v-model="qbInvoice"></vs-input>
            </vs-col>    
        </vs-row>
         <vs-row vs-align="center" vs-type="flex" vs-justify="center" class="mt-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" class="mt-2 px-2">
                <vs-button :disabled="!disabledButton" color="primary" type="filled" class="w-full" @click="submit">{{ $t('submit') }}</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" class="mt-2 px-2">
              <vs-button color="primary" type="border" class="w-full" @click="close">{{ $t('cancel') }}</vs-button>
            </vs-col>
        </vs-row>
        </template>
        <template v-else>
          <div class="font-semibold text-primary">
            {{$t('complete_qb_invoice_number_before_this_action')}}
          </div>
        </template>
        
      </div> 
    </vs-popup>
  </div>
</template>

<script>
import invoice from '@/http/requests/invoice'
export default {
  props: {
    btnColor: {
      type: String,
      default: 'primary',
    },
    btnType: {
      type: String,
      default: 'border',
    },
    btnIcon: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: 'button',
    },
    popupTitle: {
      type: String,
      default: 'title',
    },
    tooltipDelay:{
          type:String,
          default:'1.5s'
    },
    tooltipPosition:{
          type:String,
          default:'top'
    },
    tooltipText:{
        type:String,
        default:null
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      active: false,
      qbInvoice: '',
      //disabledButton: false
    }
  },
  computed:{
    disabledButton(){
      return this.qbInvoice == this.data.QBInvoiceId && this.qbInvoice != ''
    }
  },
  methods: {
    open() {
      this.qbInvoice = ''
      this.active = true
    },
    close() {
      this.active = false
    },
    submit() {
  
      let act = {
        module:'CONTRALOR',
        name:`${ this.$i18n.messages[this.$i18n.locale].regenerate_invoice} - ${this.data.QBInvoiceId}`
      }
      let actId = this.addActivity(act)
      if(!actId){
         return;
      } 
        invoice.regenerateInvoice(this.data.InvoiceId)
          .then((res) => {
            this.$vs.notify({
              color: 'success',
              title: 'Action',
              text: 'Invoice Generated',
            })
            this.updateActivity({id:actId,status:'1'})
          })
          .catch((err) => {
            this.updateActivity({id:actId,status:'4'})
             if (422 === err.response.status) {
              this.$vs.notify({
                color: 'danger',
                  title: 'Attention',
                  text: err.response.data.msg
              })
             }else{
               this.$vs.notify({
                color: 'danger',
                  title: 'Attention',
                  text: 'SERVER ERROR'
              })
             }
          });
            this.close();
     
    }
  }
}
</script>
